import * as types from './actionTypes';

const initialState = {
    mode:'',
    previewResolution:'',
    isLoading:'',
}

const cardBuilderReducer = (state=[], action) => {
    
    switch(action.type){

        case types.SetMode:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    mode: action.mode
                }
            };

        case types.SetResolution:
            return {
                ...state,
                settings:{
                    ...state.settings,
                    previewResolution: action.previewResolution
                }
            };
        
        case types.showLoadingIndicator:
            return {
                ...state,
                isLoading: true,
            }
        
        case types.hideLoadingIndicator:
            return {
                ...state,
                isLoading: false,
            }
            
        default:
            return state;
            
    }
}

export default cardBuilderReducer;